var jcpenney = {
    drawerActionButton: {
        text: 'drawerActionButton.jcpenneyDrawerActionButtonText',
        link: 'https://www.jcpenney.com/rewards'
    },
    certificateBalance: false,
    certificateExpirationDays: null,
    certificateValue: null,
    disclaimerTranslationKey: null,
    es: {
        termsAndConditionsLink: 'https://www.jcpenney.com/m/customer-service/rewards-terms-and-conditions'
    },
    en: {
        termsAndConditionsLink: 'https://www.jcpenney.com/m/customer-service/rewards-terms-and-conditions'
    },
    howToEarnPointsHeader: '',
    faqsSnapshot: true,
    isRewardTiers: false,
    isValuePropBanner: false,
    links: [],
    translationViewPrintKey: null,
    PRIVATE_LABEL: {
        actionButton: null,
        banner: 'JCPenney-banner.png',
        cashRewardsBalance: false,
        certificateHistoryImg: '',
        certificateHistory: false,
        earnings: {
            icons: {},
            titleKey: ''
        },
        faqs: null,
        rewardsBalance: false,
        snapshotTranslationKey: 'faqs.description',
        translationKey: 'faqs.jcpenneyDescription',
        valuePropImg: '',
        en: {
            propositions: []
        },
        es: {
            propositions: []
        }
    },
    DUAL_CARD: {
        actionButton: null,
        banner: 'JCPenney-banner.png',
        cashRewardsBalance: false,
        certificateHistoryImg: '',
        certificateHistory: false,
        earnings: {
            icons: {},
            titleKey: ''
        },
        faqs: null,
        rewardsBalance: false,
        snapshotTranslationKey: 'faqs.description',
        translationKey: 'faqs.jcpenneyDescription',
        valuePropImg: '',
        en: {
            propositions: []
        },
        es: {
            propositions: []
        }
    }
};
export default jcpenney;
